<script setup>
import {onMounted, ref} from "vue";
import axios from "axios";
import {useRoute} from "vue-router";
import {useI18n} from "@/i18n";

const route = useRoute()
const {t} = useI18n()
const dataForm = ref({
  name: '',
  phone: '',
  email: '',
  contents: '',
  client_path: '',
  client_ip: '',
  client_country: ''
})
const statusMessage = ref('');

function get_ip() {
  axios
      .get('https://api.ipify.org?format=json')
      .then(response => {
        dataForm.value.client_ip = response.data.ip
      })
      .catch(error => {
        console.log(error)
      })
}

function get_country() {
  axios
      .get('https://get.geojs.io/v1/ip/geo.json')
      .then(response => {
        dataForm.value.client_country = response.data.country
      })
      .catch(error => {
        console.log(error)
      })
}


function send_email() {
  dataForm.value.client_path = route.path
  if (dataForm.value.name === '') {
    statusMessage.value = t('form.nameRequired');
    return
  }
  if (dataForm.value.email === '') {
    statusMessage.value = t('form.emailRequired');
    return
  }
  if (dataForm.value.phone === '') {
    statusMessage.value = t('form.phoneRequired');
    return
  }
  axios
      .post('/api/mail', dataForm.value)
      .then(response => {
        statusMessage.value = t('form.sent');
      })
      .catch(error => {
        statusMessage.value = t('form.failed');
      })
}

onMounted(() => {
  get_ip()
  get_country()
})
</script>

<template>
  <form @submit.prevent="send_email" class="rd-form rd-mailform">
    <div class="row row-20 gutters-20">
      <div class="col-md-6">
        <div class="form-wrap">
          <input v-model="dataForm.name" class="form-input" id="contact-your-name-4" type="text" name="name"
                 data-constraints="@Required">
          <label class="form-label" for="contact-your-name-4">{{ t('form.name') }}</label>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-wrap">
          <input v-model="dataForm.email" class="form-input" id="contact-email-4" type="email" name="email"
                 data-constraints="@Email @Required">
          <label class="form-label" for="contact-email-4">{{ t('form.email') }}</label>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-wrap">
          <input v-model="dataForm.phone" class="form-input" id="contact-phone-4" type="text" name="phone"
                 data-constraints="@Numeric">
          <label class="form-label" for="contact-phone-4">{{ t('form.phone') }}</label>
        </div>
      </div>
      <div class="col-12">
        <div class="form-wrap">
          <label class="form-label" for="contact-message-4">{{ t('form.message') }}</label>
          <textarea v-model="dataForm.contents" class="form-input textarea-lg" id="contact-message-4" name="message"
                    data-constraints="@Required"></textarea>
          <p v-if="statusMessage">{{ statusMessage }}</p>
        </div>
      </div>
    </div>
    <button class="button button-primary button-winona" type="submit">{{ t('common.sendRequest') }}</button>
  </form>
</template>

<style scoped lang="scss">

</style>
